import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useKeycloak } from '../providers/KeycloakProvider';
import LoadingScreen from '../components/Common/LoadingScreen';
import { KeycloakService } from '../services/keycloakService';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, isAuthenticating, updateAuthenticationState } = useKeycloak();
  const location = useLocation();

  // Efekt uruchamiany przy każdej zmianie lokalizacji lub montowaniu komponentu
  useEffect(() => {
    // Jeśli token istnieje, spróbuj go odświeżyć
    if (KeycloakService.isLoggedIn()) {
      console.log('PrivateRoute: Weryfikacja tokenu przy zmianie lokalizacji');
      KeycloakService.updateToken(30)
        .then(refreshed => {
          if (refreshed) {
            console.log('PrivateRoute: Token został odświeżony');
            updateAuthenticationState(true);
          }
        })
        .catch(error => {
          console.error('PrivateRoute: Błąd odświeżania tokenu:', error);
          // Jeśli nie udało się odświeżyć tokenu, ale nadal mamy jakiś token,
          // próbujemy zainicjować sesję ponownie przed wylogowaniem
          KeycloakService.init()
            .then(authenticated => {
              updateAuthenticationState(authenticated);
            })
            .catch(() => {
              updateAuthenticationState(false);
            });
        });
    }
  }, [location.pathname, updateAuthenticationState]);

  // Jeśli weryfikacja tokenu jest w toku, pokaż ekran ładowania
  if (isAuthenticating) {
    return <LoadingScreen message="Trwa weryfikacja sesji..." />;
  }

  // Tylko po zakończeniu weryfikacji, jeśli użytkownik nie jest zalogowany
  // przekieruj do ekranu logowania
  if (!isAuthenticated) {
    // Zapisz bieżącą lokalizację do przekierowania po zalogowaniu
    sessionStorage.setItem('redirect_after_login', location.pathname + location.search);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Jeśli użytkownik jest zalogowany, renderuj chronioną zawartość
  return <>{children}</>
};

export default PrivateRoute;
